<template>
  <div>
    <div id="customer-profile-details" class="vx-row">
      <vx-card>
        <template slot="actions">
          <div class="flex float-right">
            <div class="con-btns-user flex items-center justify-between">
              <div class="flex mb-1">
                <vx-tooltip class="mr-2" text="Refresh" position="left">
                  <vs-button @click="fetchTenantDetails" class="mr-0" color="success" type="border"
                             icon-pack="feather" icon="icon-rotate-cw"></vs-button>
                </vx-tooltip>
              </div>
            </div>
          </div>
        </template>

        <div class="vx-col w-full">

          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSubmitForm)" autocomplete="off" id="addition-info-form">

              <div class="vx-row mb-3 mt-2">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="pricing_tier_id" name="pricing_tier_id" rules="required" v-slot="{ errors }">
                    <small class="label">Select pricing tier</small>
                    <v-select v-on:input="onSelectPricingTier" :clearable="true" placeholder="" v-model="pricing_tier" :reduce="option => option"
                              label="name" :options="pricing_tiers" :dir="$vs.rtl ? 'rtl' : 'ltr'" :closeOnSelect="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="setup_charge" name="setup_charge" rules="required" v-slot="{ errors }">
                    <small class="label">Setup charge (GBP)</small>
                    <vs-input v-model="additional_details.setup_charge" name="setup_charge" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/4  w-full md:mb-0">
                  <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                    <small class="label">Package Price(£) PCM</small>
                    <vs-input disabled v-model="additional_details.price" name="price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4  w-full md:mb-0">
                  <ValidationProvider vid="custom_price_discount" name="custom_price_discount" rules="required" v-slot="{ errors }">
                    <small class="label">Package Discount(%)</small>
                    <vs-input @input="calculatePackageTotal" v-model="additional_details.custom_price_discount" name="custom_price_discount" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4  w-full md:mb-0">
                  <ValidationProvider vid="custom_price" name="custom_price" rules="required" v-slot="{ errors }">
                    <small class="label">Customer Package discounted price(£) PCM</small>
                    <vs-input v-model="additional_details.custom_price" name="custom_price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col w-1/4 md:mb-0">
                  <ValidationProvider vid="custom_price_discount_end_date" name="custom_price_discount_end_date"
                                      :rules="Number(additional_details.custom_price_discount) === 0 ? '' : 'required'" v-slot="{ errors }">
                    <small class="label">Custom price discount end date</small>
                    <flat-pickr
                      :config="{dateFormat: 'd/m/Y'}"
                      class="hidden"
                      v-model="additional_details.custom_price_discount_end_date"
                      placeholder="Choose Date"/>
                    <flat-pickr  :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="additional_details.custom_price_discount_end_date"
                                 placeholder="Choose Date"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col w-1/4 md:mb-0">
                  <ValidationProvider vid="staffs_block" name="staffs_block" rules="required" v-slot="{ errors }">
                    <small class="label">User licence block</small>
                    <vs-input disabled v-model="additional_details.staffs_block" name="staffs_block" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="additional_staffs_block" name="additional_staffs_block" rules="required" v-slot="{ errors }">
                    <small class="label">Additional user licences</small>
                    <vs-input-number @input="calculateAdditionalBlockPrice"
                                     v-model="additional_details.additional_staffs_block"
                                     :step="pricing_tier.additional_staffs_block"  name="additional_staffs_block" min="0"/>
<!--                    <vs-input @input="calculateAdditionalBlockPrice" v-model="additional_details.additional_staffs_block" -->
<!--                              name="additional_staffs_block" class="w-full required" label=""-->
<!--                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number"/>-->
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="additional_staffs_discount" name="additional_staffs_discount" rules="required" v-slot="{ errors }">
                    <small class="label">Additional user licence block discount (%)</small>
                    <vs-input @input="calculateAdditionalBlockPrice" v-model="additional_details.additional_staffs_discount" name="additional_staffs_discount" class="w-full required" label=""
                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="additional_staffs_price" name="additional_staffs_price" rules="required" v-slot="{ errors }">
                    <small class="label">Additional user licence block price (GBP)</small>
                    <vs-input v-model="additional_details.additional_staffs_price" name="additional_staffs_price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-1/4 md:mb-0">
                  <ValidationProvider vid="additional_staffs_block" name="additional_staffs_block"
                                      :rules="Number(additional_details.additional_staffs_discount) === 0 ? '' : 'required'" v-slot="{ errors }">
                    <small class="label">Additional user licence discount end date</small>
                    <flat-pickr
                      :config="{dateFormat: 'd/m/Y'}"
                      class="hidden"
                      v-model="additional_details.additional_staffs_discount_end_date"
                      placeholder="Choose Date"/>
                    <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="additional_details.additional_staffs_discount_end_date"
                                placeholder="Choose Date"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col w-1/4 md:mb-0">
                  <ValidationProvider vid="pricing_tier_start_date" name="pricing_tier_start_date"
                                      :rules="'required'" v-slot="{ errors }">
                    <small class="label">Tier start date</small>
                    <flat-pickr
                      :config="{dateFormat: 'd/m/Y'}"
                      class="hidden"
                      v-model="additional_details.pricing_tier_start_date"
                      placeholder="Choose Date"/>
                    <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="additional_details.pricing_tier_start_date"
                                placeholder="Choose Date"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <vs-divider class="my-16"/>
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="customer_portal_price" name="customer_portal_price" rules="required" v-slot="{ errors }">
                    <small class="label">Customer portal price (GBP)</small>
                    <vs-input disabled v-model="additional_details.customer_portal_price" name="customer_portal_price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="customer_portal_discount" name="customer_portal_discount" rules="required" v-slot="{ errors }">
                    <small class="label">Customer portal discount (%)</small>
                    <vs-input @input="calculateCustomerTotal" v-model="additional_details.customer_portal_discount" name="customer_portal_discount" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="customer_portal_custom_price" name="customer_portal_custom_price" rules="required" v-slot="{ errors }">
                    <small class="label">Customer portal custom price (GBP)</small>
                    <vs-input v-model="additional_details.customer_portal_custom_price" name="customer_portal_custom_price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="additional_staffs_discount" name="additional_staffs_discount"
                                      :rules="Number(additional_details.customer_portal_discount) === 0 ? '' : 'required'" v-slot="{ errors }">
                    <small class="label">Customer portal discount end date</small>
                    <flat-pickr
                      :config="{dateFormat: 'd/m/Y'}"
                      class="hidden"
                      v-model="additional_details.customer_portal_discount_end_date"
                      placeholder="Choose Date"/>
                    <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="additional_details.customer_portal_discount_end_date"
                                placeholder="Choose Date"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="supplier_portal_price" name="supplier_portal_price" rules="required" v-slot="{ errors }">
                    <small class="label">Supplier portal price (GBP)</small>
                    <vs-input disabled v-model="additional_details.supplier_portal_price" name="supplier_portal_price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="supplier_portal_discount" name="supplier_portal_discount" rules="required" v-slot="{ errors }">
                    <small class="label">Supplier portal discount (%)</small>
                    <vs-input @input="calculateSupplierTotal" v-model="additional_details.supplier_portal_discount" name="supplier_portal_discount" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="supplier_portal_custom_price" name="supplier_portal_custom_price" rules="required" v-slot="{ errors }">
                    <small class="label">Supplier portal custom price (GBP)</small>
                    <vs-input v-model="additional_details.supplier_portal_custom_price" name="supplier_portal_custom_price" class="w-full required" label=""
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="number" step="0.01"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/4 w-full md:mb-0">
                  <ValidationProvider vid="additional_staffs_price" name="additional_staffs_price"
                                      :rules="Number(additional_details.supplier_portal_discount) === 0 ? '' : 'required'" v-slot="{ errors }">
                    <small class="label">Supplier portal discount end date</small>
                    <flat-pickr
                      :config="{dateFormat: 'd/m/Y'}"
                      class="hidden"
                      v-model="additional_details.supplier_portal_discount_end_date"
                      placeholder="Choose Date"/>

                    <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="additional_details.supplier_portal_discount_end_date"
                                placeholder="Choose Date"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
              </div>

            </form>
          </ValidationObserver>

        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const TenantRepository = RepositoryFactory.get('tenant')
const PricingRepository = RepositoryFactory.get('pricing')
import ErrorMessages from "@/mixins/ErrorMessages";
import vSelect from 'vue-select'
import SuccessMessage from "@/mixins/SuccessMessage";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: "TenantDetailsView",
  components: {
    'v-select': vSelect,
    flatPickr
  },
  data() {
    return {
      tenant_details: {},
      id: '',
      pricing_tier: {},
      pricing_tiers: [],
      additional_details: {

        setup_charge: 0.00,
        price: 0.00,
        custom_price: 0.00,
        custom_price_discount: 0,

        staffs_block: 0,
        additional_staffs_block: 0,
        additional_staffs_price: 0.00,
        additional_staffs_discount: 0,

        customer_portal_price: 0.00,
        customer_portal_custom_price: 0.00,
        customer_portal_discount: 0,

        supplier_portal_price: 0.00,
        supplier_portal_custom_price: 0.00,
        supplier_portal_discount: 0,

        custom_price_discount_end_date:'',
        additional_staffs_discount_end_date:'',
        customer_portal_discount_end_date:'',
        supplier_portal_discount_end_date:'',
      },
    }
  },
  async mounted() {
    this.id= this.$route.params.id
    await this.fetchPricingTiers()
    await this.fetchTenantDetails()
    await this.calculatePackageTotal()
    await this.calculateCustomerTotal()
    await this.calculateSupplierTotal()
    await this.calculateStaffTotal()
    await this.calculateAdditionalBlockPrice()
  },
  mixins: [ErrorMessages, SuccessMessage],
  methods: {
    async fetchTenantDetails() {
      await this.$vs.loading({
        container: '#addition-info-form',
        scale: 0.50
      });

      try {
        const { data } = (await TenantRepository.getTenantDetails(this.id)).data
        this.tenant_details = data

        if(!!this.tenant_details.additional_detail) {
          await this.getPricingTierDetails()

          this.additional_details.setup_charge = this.tenant_details.additional_detail.setup_charge
          this.additional_details.custom_price = this.tenant_details.additional_detail.custom_price
          this.additional_details.custom_price_discount = this.tenant_details.additional_detail.custom_price_discount

          this.additional_details.additional_staffs_block = this.tenant_details.additional_detail.additional_staffs_block
          this.additional_details.additional_staffs_discount = this.tenant_details.additional_detail.additional_staffs_discount

          this.additional_details.customer_portal_custom_price = this.tenant_details.additional_detail.customer_portal_custom_price
          this.additional_details.customer_portal_discount = this.tenant_details.additional_detail.customer_portal_discount

          this.additional_details.supplier_portal_custom_price = this.tenant_details.additional_detail.supplier_portal_custom_price
          this.additional_details.supplier_portal_discount = this.tenant_details.additional_detail.supplier_portal_discount

          this.additional_details.custom_price_discount_end_date = this.tenant_details.additional_detail.custom_price_discount_end_date
          this.additional_details.additional_staffs_discount_end_date = this.tenant_details.additional_detail.additional_staffs_discount_end_date
          this.additional_details.customer_portal_discount_end_date = this.tenant_details.additional_detail.customer_portal_discount_end_date
          this.additional_details.supplier_portal_discount_end_date = this.tenant_details.additional_detail.supplier_portal_discount_end_date
          this.additional_details.pricing_tier_start_date = this.tenant_details.additional_detail.pricing_tier_start_date

        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#addition-info-form > .con-vs-loading')
    },
    async calculatePackageTotal() {
      this.additional_details.custom_price = this.calculateDiscountedPrice(this.additional_details.custom_price_discount , this.additional_details.price)
    },
    async calculateCustomerTotal() {
      this.additional_details.customer_portal_custom_price = this.calculateDiscountedPrice(this.additional_details.customer_portal_discount,this.additional_details.customer_portal_price)
    },
    async calculateSupplierTotal() {
      this.additional_details.supplier_portal_custom_price = this.calculateDiscountedPrice(this.additional_details.supplier_portal_discount,this.additional_details.supplier_portal_price);
    },
    async calculateStaffTotal() {
      this.additional_details.additional_staffs_price = this.calculateDiscountedPrice(this.additional_details.additional_staffs_discount,this.additional_details.additional_staffs_price)
    },
    async calculateAdditionalBlockPrice(){
      const unit = Number(this.additional_details.additional_staffs_block) / Number(this.pricing_tier.additional_staffs_block)
      const blockPrice = (unit * this.pricing_tier.additional_staffs_price)
      this.additional_details.additional_staffs_price = this.calculateDiscountedPrice(this.additional_details.additional_staffs_discount, blockPrice)
    },
    calculateDiscountedPrice(percentage , total){
      const reduceAmount = total * (percentage/100)
      return total-reduceAmount;
    },
    onSelectPricingTier() {
      // clear values
      this.additional_details.custom_price = 0.00
      this.additional_details.custom_price_discount = 0
      this.additional_details.additional_staffs_discount = 0
      this.additional_details.customer_portal_custom_price = 0.00
      this.additional_details.customer_portal_discount = 0
      this.additional_details.supplier_portal_custom_price = 0.00
      this.additional_details.supplier_portal_discount = 0

      // data map with tiers
      this.additional_details.setup_charge = this.pricing_tier.setup_charge
      this.additional_details.price = this.pricing_tier.price

      this.additional_details.staffs_block = this.pricing_tier.staffs_block
      this.additional_details.additional_staffs_block = this.pricing_tier.additional_staffs_block
      this.additional_details.additional_staffs_price = this.pricing_tier.additional_staffs_price

      this.additional_details.customer_portal_price = this.pricing_tier.customer_portal_price
      this.additional_details.supplier_portal_price = this.pricing_tier.supplier_portal_price
    },
    async onClickSubmitForm () {
      await this.$vs.loading({
        container: '#addition-info-form',
        scale: 0.50
      });
      try {
        const payload = {
          pricing_tier_id: this.pricing_tier.id,
          setup_charge: Number(this.additional_details.setup_charge).toFixed(2),
          custom_price: this.isValueZero(this.additional_details.custom_price) ? '0.00' : Number(this.additional_details.custom_price).toFixed(2),
          custom_price_discount: this.isValueZero(this.additional_details.custom_price_discount) ? 0.00 : this.additional_details.custom_price_discount,
          additional_staffs_block: this.additional_details.additional_staffs_block,
          additional_staffs_discount: this.isValueZero(this.additional_details.additional_staffs_discount) ? 0 : this.additional_details.additional_staffs_discount,
          customer_portal_custom_price: this.isValueZero(this.additional_details.customer_portal_custom_price) ? Number(0).toFixed(2) : Number(this.additional_details.customer_portal_custom_price).toFixed(2),
          customer_portal_discount: this.isValueZero(this.additional_details.customer_portal_discount) ? 0.00 : this.additional_details.customer_portal_discount,
          supplier_portal_custom_price: this.isValueZero(this.additional_details.supplier_portal_custom_price) ? Number(0).toFixed(2) : Number(this.additional_details.supplier_portal_custom_price).toFixed(2),
          supplier_portal_discount: this.isValueZero(this.additional_details.supplier_portal_discount) ? 0.00 : this.additional_details.supplier_portal_discount,
          custom_price_discount_end_date: this.additional_details.custom_price_discount_end_date,
          additional_staffs_discount_end_date: this.additional_details.additional_staffs_discount_end_date,
          customer_portal_discount_end_date: this.additional_details.customer_portal_discount_end_date,
          supplier_portal_discount_end_date: this.additional_details.supplier_portal_discount_end_date,
          pricing_tier_start_date: this.additional_details.pricing_tier_start_date
        }
        await TenantRepository.updateCreateTenantAdditionalDetails(this.id, payload)
        this.showSuccessMessage('Tenant details updated successfully')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#addition-info-form > .con-vs-loading')
    },
    async fetchPricingTiers() {
      try {
        const {data} = await PricingRepository.get()
        this.pricing_tiers =  data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getPricingTierDetails() {
      try {
        const { data } = (await PricingRepository.getPricingTierDetails(this.tenant_details.additional_detail.pricing_tier_id)).data
        this.pricing_tier = data
        this.additional_details.price = this.pricing_tier.price
        this.additional_details.staffs_block = this.pricing_tier.staffs_block
        this.additional_details.additional_staffs_price = this.pricing_tier.additional_staffs_price
        this.additional_details.customer_portal_price = this.pricing_tier.customer_portal_price
        this.additional_details.supplier_portal_price = this.pricing_tier.supplier_portal_price
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    isValueZero(value) {
      return Number(value) === 0
    }
  },
}
</script>

<style scoped>

</style>
